export default {
  create(url) {
    return {
      getPath: () => url,
    };
  },
};
